<script lang="ts" setup>
    import { storeToRefs } from 'pinia'
    import { useQuasar } from 'quasar'
    import { useAppStore } from '~~/stores/app'
    
    const $q = useQuasar()
    const appStore = useAppStore()
    
    const { isDarkMode } = storeToRefs(appStore)
    
    watch(
        isDarkMode,
        (newValue) => $q.dark.set(newValue),
        { immediate: true },
    )
</script>

<template>
    <nuxt-layout>
        <nuxt-page />
    </nuxt-layout>
</template>
